import React, { useState, useRef, useEffect } from 'react';
import { FiDownload, FiChevronDown } from 'react-icons/fi';

/**
 * Botón con menú desplegable para elegir el formato de exportación
 * (PDF, Excel, etc.). Estándar de UX para reportes con más de un formato
 * de salida: un solo botón "Exportar" en vez de un botón por formato.
 *
 * opciones: [{ label, icono, onClick, disabled }]
 */
export default function BotonExportar({ texto = 'Exportar', opciones, disabled = false, cargando = false, variante = 'solido' }) {
  const [abierto, setAbierto] = useState(false);
  const contenedorRef = useRef(null);

  useEffect(() => {
    function alHacerClicFuera(evento) {
      if (contenedorRef.current && !contenedorRef.current.contains(evento.target)) {
        setAbierto(false);
      }
    }
    document.addEventListener('mousedown', alHacerClicFuera);
    return () => document.removeEventListener('mousedown', alHacerClicFuera);
  }, []);

  const claseBase = variante === 'solido'
    ? 'bg-color-secundario text-white hover:bg-opacity-90'
    : 'border border-color-primario text-color-primario hover:bg-gray-100';

  return (
    <div className="relative print:hidden" ref={contenedorRef}>
      <button
        type="button"
        onClick={() => setAbierto(prev => !prev)}
        disabled={disabled || cargando}
        className={`flex items-center gap-2 px-4 py-2 rounded-xl transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${claseBase}`}
        aria-haspopup="menu"
        aria-expanded={abierto}
      >
        <FiDownload size={18} className={cargando ? 'animate-pulse' : ''} />
        {texto}
        <FiChevronDown size={16} className={`transition-transform ${abierto ? 'rotate-180' : ''}`} />
      </button>

      {abierto && (
        <div
          role="menu"
          className="absolute right-0 mt-1 w-52 bg-white border border-gray-200 rounded-xl shadow-lg z-50 overflow-hidden py-1"
        >
          {opciones.map((opcion, idx) => (
            <button
              key={idx}
              type="button"
              role="menuitem"
              onClick={() => {
                setAbierto(false);
                opcion.onClick();
              }}
              disabled={opcion.disabled}
              className="flex items-center gap-2.5 w-full px-4 py-2.5 text-sm text-left text-gray-700 hover:bg-gray-100 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {opcion.icono}
              {opcion.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
